<template>
  <div class="goodsManagePage">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="input_wrap flex-rowl">
      <div class="input_box search">
        <van-field
          v-model="params.keyword"
          placeholder="输入商品生产组码查找"
          @focus="handleFocus"
          @blur="handleBlur"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="primary-button" @click="handleSearch">查找→</div>
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <div class="img_box" @click="handleGo(1,item.id)">
            <!-- <img :src="item.img" alt="" /> -->
            <van-image width="100%" height="100%" fit="cover" :src="item.ercode" />
          </div>
          <div class="block" @click="handleGo(1,item.id)">
            <p>商品名称：{{ item.cmidstr  }}</p>
            <p>商品SKU编码：{{ item.sku }}</p>
            <p>属性标签&属性标签值：{{ item.attrname }} {{item.attrvalue}}</p>
          </div>
          <div class="block" @click="handleGo(1,item.id)">
            <p>生产商：{{ item.productidstr  }}</p>
            <p>生产批次：{{ item.productno }}</p>
            <p>投产时间：{{ item.startdate | formatDate }}</p>
          </div>
          <div class="block" @click="handleGo(1,item.id)">
            <p>预期生产数量：{{ item.plannum  }}</p>
            <p>初始货码：{{ item.biancode }}</p>
            <p>创建日期：{{ item.createdate | formatDate }}</p>
          </div>
          <div class="editBtn_group flex-rowr">
            <div class="editBtn" @click="handleGo(1,item.id)">编辑商品生产→</div>
            <div class="editBtn" @click="handleGo(2,item.id)">货码管理→</div>
          </div>
          
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleGo(1,'')">添加商品生产计划</div>
    </div>
  </div>
</template>

<script>
import { getMenuAuthTwo, encryptstringadd, encryptstringview } from "../../../api/api";
import { getShopProductionCode } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cProductionCode",
  data() {
    return {
      isShowTabbar: true,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      dataList: [],
      finished: false,
      refreshing: false,
      params: {
        pageindex: 1,
        pagesize: 20,
        keyword: "",
        cmid: "",
      },
      listTotal: 0,
      loading: false, // 是否正在加载中
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    // shopItem
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.cmid = id;
        this.initData();
      } else {
        this.$router.back();
      }
    },
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleSearch() {
      this.params.pageindex = 1;
      this.dataList = [];
      this.initData();
    },
    initData() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getShopProductionCode(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },

    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.initData();
      }
    },

    handleReturn() {
      history.back();
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

    handleGo(type, id) {
       let {cmid} = this.params
      if (type == 1) {
        if (id) {
          this.encryptstringadd("cProductionCodeSet", { id, cmid });
          // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
        } else {
          this.encryptstringadd("cProductionCodeSet", {id: '', cmid});
        }
      } else {
        this.encryptstringadd("cProductionCodeDetail", { id, cmid });
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  padding-bottom: 420px;
  .input_wrap {
    padding: 20px 45px 30px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .input_tip {
    font-size: 14px;
    margin-bottom: 60px;
    color: #aaaaaa;
    .btn {
      margin-left: 30px;
      background: #6e5c86;
      color: #fff;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
  .main_content {
    width: 650px;
    margin: 60px auto 100px;
    .data_list {
      // padding-bottom: 320px;
      .item_card {
        border: 2px solid #dedede;
        border-radius: 30px;
        padding: 25px 37px 57px;
        box-sizing: border-box;
        font-size: 22px;
        color: #404d6c;
        position: relative;
        margin-bottom: 55px;
        .block {
          margin-bottom: 30px;
        }
        .img_box {
          width: 250px;
          height: 250px;
          margin: 35px auto;
          background: #f8f8f8;
          overflow: hidden;
        }
        h1 {
          font-size: 30px;
          color: #404d6c;
          margin-bottom: 12px;
        }
        p {
          margin-bottom: 10px;
        }
        .editBtn {
          width: 200px;
          height: 50px;
          background: #6e5c86;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          color: #fff;
          margin-top: 10px;
          &:last-child {
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>